import { formatLocationTag, createLocationTagsFromString } from '@/core';
import deepCopy from 'deepcopy';

function setSearchFilterDateFrom({ commit }, date) {
	commit('updateSearchFilterDate', { key: 'date', isFrom: true, date });
}
function setSearchFilterDateTo({ commit }, date) {
	commit('updateSearchFilterDate', { key: 'date',isFrom: false, date });
}
function setSearchFilterDateType({ commit }, value) {
	commit('setSearchFilterValue', { key: 'dateType', value });
}
function addFromDespatchParty({ commit }, tag) {
	commit('addSearchFilterTagList', { key: 'fromDespatchParty', tag: formatLocationTag(tag) });
}
function addFromDespatchPartyString({ commit }, value) {
	commit('appendSearchFilterTagList', { key: 'fromDespatchParty', tags: createLocationTagsFromString(value) });
}
function setFromDespatchParty({ commit }, tagList) {
	commit('setSearchFilterTagList', { key: 'fromDespatchParty', tagList: tagList.map(tag => formatLocationTag(tag)) });
}
function addToDeliveryParty({ commit }, tag) {
	commit('addSearchFilterTagList', { key: 'toDeliveryParty', tag: formatLocationTag(tag) });
}
function addToDeliveryPartyString({ commit }, value) {
	commit('appendSearchFilterTagList', { key: 'toDeliveryParty', tags: createLocationTagsFromString(value) });
}
function setToDeliveryParty({ commit }, tagList) {
	commit('setSearchFilterTagList', { key: 'toDeliveryParty', tagList: tagList.map(tag => formatLocationTag(tag)) });
}
function addCustomer({ commit }, tag) {
	commit('addSearchFilterTagList', { key: 'customer', tag });
}
function addCustomerString({ commit }, value) {
	commit('addSearchFilterTagList', { key: 'customer', tag:{ id:value,name:value } });
}
function setCustomer({ commit }, tagList) {
	commit('setSearchFilterTagList', { key: 'customer', tagList });
}
function addGoodsType({ commit }, tag) {
	commit('addSearchFilterTagList', { key: 'goodsTypes', tag });
}
function setGoodsType({ commit }, tagList) {
	commit('setSearchFilterTagList', { key: 'goodsTypes', tagList });
}
function addOrderTypes({ commit }, tag) {
	commit('addSearchFilterTagList', { key: 'orderTypes', tag });
}
function setOrderTypes({ commit }, tagList) {
	commit('setSearchFilterTagList', { key: 'orderTypes', tagList });
}
function setHasAtd({ commit }, value) {
	commit('setSearchFilterValue', { key: 'hasAtd', value });
}
function setHasAta({ commit }, value) {
	commit('setSearchFilterValue', { key: 'hasAta', value });
}
function addEconomicalStatus({ commit }, tag) {
	commit('addSearchFilterValueList', { key: 'economicalStatus', tag });
}
function setEconomicalStatus({ commit }, tagList) {
	commit('setSearchFilterTagList', { key: 'economicalStatus', tagList });
}
function addOrderStatus({ commit }, tag) {
	commit('addSearchFilterValueList', { key: 'orderStatus', tag });
}
function setOrderStatus({ commit }, tagList) {
	commit('setSearchFilterTagList', { key: 'orderStatus', tagList });
}
function addInputTagsOnSearch({ commit }, inputs) {
	if (inputs.fromDespatchParty)
		commit('appendSearchFilterTagList', { key: 'fromDespatchParty', tags: createLocationTagsFromString(inputs.fromDespatchParty) });
	if (inputs.toDeliveryParty)
		commit('appendSearchFilterTagList', { key: 'toDeliveryParty', tags: createLocationTagsFromString(inputs.toDeliveryParty) });
	if (inputs.customer)
		commit('addSearchFilterTagList', { key: 'customer', tag:{ id:inputs.customer,name:inputs.customer } });
	if (inputs.waybillNumber)
		commit('addSearchFilterTagList', { key: 'waybillNumber', tag:{ id:inputs.waybillNumber } });
}
function addReferences({ commit }, tag) {
	commit('addSearchFilterTagList', { key: 'references', tag });
}
function setReferences({ commit }, tagList) {
	commit('setSearchFilterTagList', { key: 'references', tagList });
}
function setReferencesText({ commit }, value) {
	commit('setSearchFilterValue', { key: 'referencesText', value });
}

function addWaybillNumber({ commit }, value) {
	commit('addSearchFilterTagList', { key: 'waybillNumber', tag:{ id:value } });
}
function setWaybillNumber({ commit }, tagList) {
	commit('setSearchFilterTagList', { key: 'waybillNumber', tagList });
}
function changeTagOpCode({ commit }, { key, tag }) {
	let tagCopy = deepCopy(tag);
	if (!tagCopy.op || tagCopy.op === 'OR') {
		tagCopy.op = 'AND';
		tagCopy.color = 'green';
	} else if (tagCopy.op === 'AND') {
		tagCopy.op = 'NOT';
		tagCopy.color = 'red';
	} else if (tagCopy.op === 'NOT') {
		tagCopy.op = 'OR';
		tagCopy.color = 'blue';
	}
	commit('updateSearchFilterTag', { key, tag: tagCopy });
}

function changeTagOpCodeBetweenNotAndOr({ commit }, { key, tag }) {
	let tagCopy = deepCopy(tag);
	if (tagCopy.op && tagCopy.op === 'NOT') {
		tagCopy.op = 'OR';
		tagCopy.color = 'blue';
	} else {
		tagCopy.op = 'NOT';
		tagCopy.color = 'red';
	}
	commit('updateSearchFilterTag', { key, tag: tagCopy });
}

function setInboundEdi({ commit }, value) {

	if (value)
		commit('setSearchFilterValue', { key: 'mustHaveInboundEdi', value: true });
	else
		commit('setSearchFilterValue', { key: 'mustHaveInboundEdi', value: false });

	commit('setSearchFilterValue', { key: 'inboundEdi', value: value.toUpperCase() });
}

function setMustHaveInboundEdi({ commit }, value) {
	commit('setSearchFilterValue', { key: 'mustHaveInboundEdi', value });
}

function setMustHaveDeviation({ commit }, value) {
	commit('setSearchFilterValue', { key: 'mustHaveDeviation', value });
}

export default {
	setSearchFilterDateFrom,
	setSearchFilterDateTo,
	setSearchFilterDateType,
	addFromDespatchParty,
	addFromDespatchPartyString,
	setFromDespatchParty,
	addToDeliveryParty,
	addToDeliveryPartyString,
	setToDeliveryParty,
	addCustomer,
	addCustomerString,
	setCustomer,
	addGoodsType,
	setGoodsType,
	addOrderTypes,
	setOrderTypes,
	setHasAtd,
	setHasAta,
	addEconomicalStatus,
	setEconomicalStatus,
	addOrderStatus,
	setOrderStatus,
	addInputTagsOnSearch,
	addReferences,
	setReferences,
	setReferencesText,
	addWaybillNumber,
	setWaybillNumber,
	changeTagOpCode,
	changeTagOpCodeBetweenNotAndOr,
	setInboundEdi,
	setMustHaveInboundEdi,
	setMustHaveDeviation,
};